import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initMixpanel, track, register } from '../utils/mixpanel';

const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;

export default function MixpanelProvider({ children }) {
  const location = useLocation();

  useEffect(() => {
    initMixpanel(MIXPANEL_TOKEN);
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(k => {
      const v = params.get(k);
      if (v) utm[k] = v;
    });
    if (Object.keys(utm).length) register(utm);
  }, []);

  useEffect(() => {
    track('Page Viewed', {
      path: location.pathname,
      title: document.title || '',
    });
  }, [location]);

  return children;
}


